import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useCallback, useEffect, useState } from 'react';

import ExpressionModal from './ExpressionModal';
import EntityModel from './ExpressionModal/EntityModel';
import InteractionModel from './ExpressionModal/InteractionActionModel';
import { MODEL_PICKER_MODAL_STYLES } from '../../../../constants/CommonStylesConstants';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { getUITA } from '../../../../utils/commonUtils';
import {
  ENTITY_MODEL_EDITOR,
  EXPRESSION_EDITOR,
  INTERACTION_MODEL_EDITOR,
} from '../../../constants/editor.constants';

const useStyles = makeStyles({
  modal: {
    minWidth: '70%',
  },
  entityModelModal: MODEL_PICKER_MODAL_STYLES,
});

const TablePropertiesModal = ({ type, row, handleUpdate, onClose }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [value, setValue] = useState(row[row.currentKey]);

  useEffect(() => {
    setValue(row[row.currentKey]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[row.currentKey]]);

  const onUpdateValue = useCallback(
    (param) => {
      const newValue = typeof param === 'function' ? param(value) : param;
      handleUpdate(row.key, row.currentKey, newValue);
      onClose();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row]
  );

  const onSelectValue = useCallback(
    (param) => {
      const newValue = typeof param === 'function' ? param(value) : param;
      setValue(newValue);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row]
  );

  const updateExpressionText = ({ target }) => {
    setValue(target.value);
  };

  const updateExpressionTextFieldFromOutside = (updateValue) => {
    const updatedValue = updateValue(value);
    setValue(updatedValue);
  };

  const componentType = (type) => {
    switch (type) {
      case EXPRESSION_EDITOR:
        return (
          <ExpressionModal
            onChange={updateExpressionTextFieldFromOutside}
            expression={value}
            onBlurEditor={updateExpressionText}
          />
        );
      case ENTITY_MODEL_EDITOR:
        return (
          <EntityModel
            action={true}
            select={onSelectValue}
            change={onUpdateValue}
            translation={false}
            showSearch
            showTitle={false}
          />
        );
      case INTERACTION_MODEL_EDITOR:
        return <InteractionModel select={onSelectValue} change={onUpdateValue} />;

      default:
        return null;
    }
  };

  return (
    <Modal
      open
      title={translateString(type)}
      variant="default"
      className={
        type === ENTITY_MODEL_EDITOR || type === INTERACTION_MODEL_EDITOR
          ? classes.entityModelModal
          : classes.modal
      }
      onClose={onClose}
      buttonProps={[
        {
          label: translateString('Cancel'),
          onClick: onClose,
          'ui-ta': getUITA('Table Properties Modal', 'Cancel Btn'),
        },
        {
          label: translateString('Save'),
          onClick: () => {
            handleUpdate(row.key, row.currentKey, value);
            onClose();
          },
          'ui-ta': getUITA('Table Properties Modal', 'Save Btn'),
        },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    >
      {componentType(type)}
    </Modal>
  );
};

export default TablePropertiesModal;
